<template>
  <div class="submit-failure">
    <div class="form-section">
      <div class="form-row">
        <div class="form-field">
          <p class="form-field-title">故障机构：</p>
          <el-select
            v-model="associatedInstitutionId"
            placeholder="请选择机构"
            class="form-field-select"
            filterable
          >
            <el-option
              v-for="hospital in hospitalList"
              :key="hospital.value"
              :label="hospital.label"
              :value="hospital.value"
            ></el-option>
          </el-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <p class="form-field-title">故障详情记录：</p>
          <el-input
            v-model="processingDetails"
            type="textarea"
            placeholder="请详细记录故障的具体情况和处理过程"
            class="form-field-textarea"
            :rows="4"
          >
          </el-input>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <p class="form-field-title">故障图片/视频：</p>
          <div class="upload-images-container">
            <el-upload
              v-show="uploadFiles.length < 3"
              :action="''"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :file-list="[]"
              :auto-upload="true"
              class="upload-images"
            >
              <div class="upload-images-add">
                <i class="upload-image-add-icon">+</i>
                <span class="upload-image-add-text">上传图片/视频</span>
              </div>
            </el-upload>
            <div class="upload-images-list">
              <div
                v-for="(file, index) in uploadFiles"
                :key="index"
                class="upload-image-item"
              >
                <div class="upload-image-preview">
                  <img v-if="file.type.startsWith('image/')" :src="file.url" alt="故障图片" />
                  <img v-else-if="file.type.startsWith('video/')" src="@/assets/imgs/device_file_video.png" alt="视频图标" />
                </div>
                <div class="upload-image-name">{{ file.name }}</div>
                <div class="upload-image-actions">
                  <i class="el-icon-delete" @click="handleDelete(index)"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option, Input, Upload } from "element-ui";

export default {
  name: "SubmitFailure",
  
  components: {
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElUpload: Upload,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      associatedInstitutionId: null,
      processingDetails: "",
      uploadFiles: [], // 存储已上传的文件信息
    };
  },

  mounted() {
    this.initializeAssociatedInstitution();
  },

  methods: {
    initializeAssociatedInstitution() {
      // 如果设备有当前机构，自动选中对应的机构
      if (this.deviceData && this.deviceData.outboundHospitalId) {
        // 使用outboundHospitalId作为当前机构
        this.associatedInstitutionId = this.deviceData.outboundHospitalId;
      } 
      // else if (this.deviceData && this.deviceData.deviceHospitalId) {
      //   // 如果没有outboundHospitalId，使用deviceHospitalId
      //   this.associatedInstitutionId = this.deviceData.deviceHospitalId;
      // }
    },
    // 上传前处理
    beforeUpload(file) {
      // 检查文件类型
      const isImageOrVideo = file.type.startsWith('image/') || file.type.startsWith('video/');
      if (!isImageOrVideo) {
        this.$toast.showRed('只能上传图片或视频文件');
        return false;
      }
      // 手动上传
      this.uploadFile(file);
      return false;
    },
    
    // 手动上传文件
    async uploadFile(file) {
      try {
        
        // 构造formData
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', file.name);
        
        // 调用上传接口
        const response = await this.$api.uplodFileWithNameRequest(formData);
        
        // 添加到已上传文件列表
        this.uploadFiles.push({
          name: file.name,
          type: file.type,
          url: response // 根据响应拦截器，成功响应会直接返回data.data，所以使用response.url
        });
        
        this.$toast.showGreen('上传成功');
      } catch (error) {
        this.$toast.showRed('上传失败：' + error);
        console.error('文件上传失败:', error);
      }
    },
    
    // 处理上传成功
    handleUploadSuccess(response, file) {
      // 这个方法在使用action属性时会被调用，这里我们使用手动上传，所以可能不会用到
    },
    
    // 处理上传失败
    handleUploadError(error, file) {
      this.$toast.showRed('上传失败：' + error);
    },
    
    // 删除已上传的文件
    handleDelete(index) {
      this.uploadFiles.splice(index, 1);
    },
    
    onSubmit: function () {
      // 构造提交数据
      const submitData = {
        deviceId: this.deviceData.id,
        associatedInstitutionId: this.associatedInstitutionId,
        processingDetails: this.processingDetails,
        deviceSn: this.deviceData.deviceSn,
        faultImages: this.uploadFiles.map(file => file.url).join(',') // 多个文件URL用逗号分隔
      };
      console.log('submitData', submitData);
      this.$emit("onSubmit", submitData);
    },
  },
};
</script>

<style lang="scss" scoped>
.submit-failure {
  width: 100%;

  .form-section {
    padding: rem(10) 0;
  }

  .required {
    color: #ff4d4f;
  }

  .form-row {
    display: flex;
    gap: rem(20);
    margin-bottom: rem(16);

    .form-field {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: rem(8);

      &-title {
        font-weight: 500;
        margin: 0;
        font-size: rem(14);
      }

      &-select,
      &-input {
        ::v-deep .el-input {
          height: rem(32);
        }
      }

      &-textarea {
        ::v-deep .el-textarea__inner {
          min-height: rem(80);
          font-family: inherit;
        }
      }

      .upload-images-container {
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          gap: rem(10);
          
          .upload-images {
            display: inline-block;
            
            .upload-images-add {
              width: rem(100);
              height: rem(100);
              border: 2px dashed #d9d9d9;
              border-radius: rem(4);
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              cursor: pointer;
              color: #666;
              transition: all 0.3s;

              &:hover {
                border-color: #325FAC;
                color: #325FAC;
              }

              .upload-image-add-icon {
                font-size: rem(24);
                margin-bottom: rem(4);
              }

              .upload-image-add-text {
                font-size: rem(12);
              }
            }
          }

          .upload-images-list {
            display: flex;
            flex-wrap: wrap;
            gap: rem(10);

            .upload-image-item {
              position: relative;
              width: rem(100);
              height: rem(100);
              border: 1px solid #eee;
              border-radius: rem(4);
              overflow: hidden;
              background-color: #fafafa;

              .upload-image-preview {
                width: 100%;
                height: rem(80);
                overflow: hidden;

                img,
                video {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }

              .upload-image-name {
                height: rem(20);
                line-height: rem(20);
                font-size: rem(12);
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .upload-image-actions {
                position: absolute;
                top: 0;
                right: 0;
                background-color: rgba(0, 0, 0, 0.5);
                color: white;
                cursor: pointer;
                padding: rem(4);

                i {
                  font-size: rem(12);
                }
              }
            }
          }

        .upload-images-tip {
          font-size: rem(12);
          color: #999;
          margin-top: rem(8);
        }
      }
    }
  }
}
</style>